import { DocumentoPasta } from "../DocumentoPasta";
import DocumentoPastaAcessoGrupo from "./DocumentoPastaAcessoGrupo";
import DocumentoPastaAcessoUsuario from "./DocumentoPastaAcessoUsuario";


export default class DocumentoPastaAcesso {
    pasta: DocumentoPasta|null;
    usuarios: DocumentoPastaAcessoUsuario[];
    grupos: DocumentoPastaAcessoGrupo[];

    constructor(
        pasta: DocumentoPasta|null = null,
        usuarios: DocumentoPastaAcessoUsuario[] = [], 
        grupos: DocumentoPastaAcessoGrupo[] = []
    ) {
        this.pasta = pasta;
        this.usuarios = usuarios;
        this.grupos = grupos;
    }
}